// This file is auto-generated by scripts/sync-sol-catalog-guidelines.sh.
// Do not edit manually.

export interface GeneratedCatalogDocument {
  readonly id: string;
  readonly title: string;
  readonly routePath: string;
  readonly assetPath: string;
  readonly group: 'overview' | 'general' | 'components' | 'ai-directives';
  readonly sourceRelativePath: string;
  readonly isIndex: boolean;
}

export const generatedCatalogDocuments = [
  {
    id: 'documents/ux-foundation/ai-directives/design-system',
    title: 'Design system',
    routePath: 'documents/ux-foundation/ai-directives/design-system',
    assetPath: 'public/markdown/generated/ux-foundation/ai-directives/design-system.md',
    group: 'ai-directives',
    sourceRelativePath: 'ai-directives/design-system.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/ai-directives/outpost24-context',
    title: 'Outpost24 context',
    routePath: 'documents/ux-foundation/ai-directives/outpost24-context',
    assetPath: 'public/markdown/generated/ux-foundation/ai-directives/outpost24-context.md',
    group: 'ai-directives',
    sourceRelativePath: 'ai-directives/outpost24-context.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/ai-directives/ux-directives',
    title: 'UX directives',
    routePath: 'documents/ux-foundation/ai-directives/ux-directives',
    assetPath: 'public/markdown/generated/ux-foundation/ai-directives/ux-directives.md',
    group: 'ai-directives',
    sourceRelativePath: 'ai-directives/ux-directives.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/banners',
    title: 'Banners',
    routePath: 'documents/ux-foundation/components/banners',
    assetPath: 'public/markdown/generated/ux-foundation/components/banners.md',
    group: 'components',
    sourceRelativePath: 'components/banners.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/buttons',
    title: 'Buttons',
    routePath: 'documents/ux-foundation/components/buttons',
    assetPath: 'public/markdown/generated/ux-foundation/components/buttons.md',
    group: 'components',
    sourceRelativePath: 'components/buttons.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/context-menus',
    title: 'Context menus',
    routePath: 'documents/ux-foundation/components/context-menus',
    assetPath: 'public/markdown/generated/ux-foundation/components/context-menus.md',
    group: 'components',
    sourceRelativePath: 'components/context-menus.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/dialogs',
    title: 'Dialogs',
    routePath: 'documents/ux-foundation/components/dialogs',
    assetPath: 'public/markdown/generated/ux-foundation/components/dialogs.md',
    group: 'components',
    sourceRelativePath: 'components/dialogs.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/empty-states',
    title: 'Empty states',
    routePath: 'documents/ux-foundation/components/empty-states',
    assetPath: 'public/markdown/generated/ux-foundation/components/empty-states.md',
    group: 'components',
    sourceRelativePath: 'components/empty-states.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/notifications',
    title: 'Notifications',
    routePath: 'documents/ux-foundation/components/notifications',
    assetPath: 'public/markdown/generated/ux-foundation/components/notifications.md',
    group: 'components',
    sourceRelativePath: 'components/notifications.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/spinners-and-progress-bars',
    title: 'Spinners and progress bars',
    routePath: 'documents/ux-foundation/components/spinners-and-progress-bars',
    assetPath: 'public/markdown/generated/ux-foundation/components/spinners-and-progress-bars.md',
    group: 'components',
    sourceRelativePath: 'components/spinners-&-progress-bars.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/switches',
    title: 'Switches',
    routePath: 'documents/ux-foundation/components/switches',
    assetPath: 'public/markdown/generated/ux-foundation/components/switches.md',
    group: 'components',
    sourceRelativePath: 'components/switches.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/tables',
    title: 'Tables',
    routePath: 'documents/ux-foundation/components/tables',
    assetPath: 'public/markdown/generated/ux-foundation/components/tables.md',
    group: 'components',
    sourceRelativePath: 'components/tables.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/tabs',
    title: 'Tabs',
    routePath: 'documents/ux-foundation/components/tabs',
    assetPath: 'public/markdown/generated/ux-foundation/components/tabs.md',
    group: 'components',
    sourceRelativePath: 'components/tabs.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/tooltips',
    title: 'Tooltips',
    routePath: 'documents/ux-foundation/components/tooltips',
    assetPath: 'public/markdown/generated/ux-foundation/components/tooltips.md',
    group: 'components',
    sourceRelativePath: 'components/tooltips.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/components/wizard-dialogs',
    title: 'Wizard dialogs',
    routePath: 'documents/ux-foundation/components/wizard-dialogs',
    assetPath: 'public/markdown/generated/ux-foundation/components/wizard-dialogs.md',
    group: 'components',
    sourceRelativePath: 'components/wizard-dialogs.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/decision-tree',
    title: 'Decision tree',
    routePath: 'documents/ux-foundation/fallbacks/decision-tree',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/decision-tree.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/decision-tree.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/form-level-alerts',
    title: 'Form-level alert messages',
    routePath: 'documents/ux-foundation/fallbacks/form-level-alerts',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/form-level-alerts.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/form-level-alerts.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/grammar-checklist',
    title: 'Grammar and style checklist',
    routePath: 'documents/ux-foundation/fallbacks/grammar-checklist',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/grammar-checklist.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/grammar-checklist.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/inline-validation',
    title: 'Inline validation messages',
    routePath: 'documents/ux-foundation/fallbacks/inline-validation',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/inline-validation.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/inline-validation.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/patterns-and-formulas',
    title: 'Patterns and formulas',
    routePath: 'documents/ux-foundation/fallbacks/patterns-and-formulas',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/patterns-and-formulas.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/patterns-and-formulas.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/quick-reference',
    title: 'Quick reference',
    routePath: 'documents/ux-foundation/fallbacks/quick-reference',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/quick-reference.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/quick-reference.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/fallbacks/readme',
    title: 'Fallback microcopy',
    routePath: 'documents/ux-foundation/fallbacks/readme',
    assetPath: 'public/markdown/generated/ux-foundation/fallbacks/readme.md',
    group: 'overview',
    sourceRelativePath: 'fallbacks/README.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/4px-factor',
    title: '4px factor',
    routePath: 'documents/ux-foundation/general/4px-factor',
    assetPath: 'public/markdown/generated/ux-foundation/general/4px-factor.md',
    group: 'general',
    sourceRelativePath: 'general/4px-factor.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/accessibility-is-perception',
    title: 'Accessibility is perception',
    routePath: 'documents/ux-foundation/general/accessibility-is-perception',
    assetPath: 'public/markdown/generated/ux-foundation/general/accessibility-is-perception.md',
    group: 'general',
    sourceRelativePath: 'general/accessibility-is-perception.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/avoid-horizontal-scrolling',
    title: 'Avoid horizontal scrolling',
    routePath: 'documents/ux-foundation/general/avoid-horizontal-scrolling',
    assetPath: 'public/markdown/generated/ux-foundation/general/avoid-horizontal-scrolling.md',
    group: 'general',
    sourceRelativePath: 'general/avoid-horizontal-scrolling.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/built-to-pivot',
    title: 'Built to pivot',
    routePath: 'documents/ux-foundation/general/built-to-pivot',
    assetPath: 'public/markdown/generated/ux-foundation/general/built-to-pivot.md',
    group: 'general',
    sourceRelativePath: 'general/built-to-pivot.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/colors-and-the-palette',
    title: 'Colors and the palette',
    routePath: 'documents/ux-foundation/general/colors-and-the-palette',
    assetPath: 'public/markdown/generated/ux-foundation/general/colors-and-the-palette.md',
    group: 'general',
    sourceRelativePath: 'general/colors-&-the-palette.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/components-as-puzzle-pieces',
    title: 'Components as puzzle pieces',
    routePath: 'documents/ux-foundation/general/components-as-puzzle-pieces',
    assetPath: 'public/markdown/generated/ux-foundation/general/components-as-puzzle-pieces.md',
    group: 'general',
    sourceRelativePath: 'general/components-as-puzzle-pieces.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/consistency',
    title: 'Consistency',
    routePath: 'documents/ux-foundation/general/consistency',
    assetPath: 'public/markdown/generated/ux-foundation/general/consistency.md',
    group: 'general',
    sourceRelativePath: 'general/consistency.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/date-and-time-formatting',
    title: 'Date and time formatting',
    routePath: 'documents/ux-foundation/general/date-and-time-formatting',
    assetPath: 'public/markdown/generated/ux-foundation/general/date-and-time-formatting.md',
    group: 'general',
    sourceRelativePath: 'general/date-and-time-formatting.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/design-philosophy',
    title: 'The design philosophy',
    routePath: 'documents/ux-foundation/general/design-philosophy',
    assetPath: 'public/markdown/generated/ux-foundation/general/design-philosophy.md',
    group: 'general',
    sourceRelativePath: 'general/design-philosophy.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/discipline-is-freeing',
    title: 'Discipline is freeing',
    routePath: 'documents/ux-foundation/general/discipline-is-freeing',
    assetPath: 'public/markdown/generated/ux-foundation/general/discipline-is-freeing.md',
    group: 'general',
    sourceRelativePath: 'general/discipline-is-freeing.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/error-messages',
    title: 'Error messages',
    routePath: 'documents/ux-foundation/general/error-messages',
    assetPath: 'public/markdown/generated/ux-foundation/general/error-messages.md',
    group: 'general',
    sourceRelativePath: 'general/error-messages.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/feedback-and-response',
    title: 'Feedback and response',
    routePath: 'documents/ux-foundation/general/feedback-and-response',
    assetPath: 'public/markdown/generated/ux-foundation/general/feedback-and-response.md',
    group: 'general',
    sourceRelativePath: 'general/feedback-and-response.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/form-validation',
    title: 'Form validation',
    routePath: 'documents/ux-foundation/general/form-validation',
    assetPath: 'public/markdown/generated/ux-foundation/general/form-validation.md',
    group: 'general',
    sourceRelativePath: 'general/form-validation.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/handling-missing-information',
    title: 'Handling missing information',
    routePath: 'documents/ux-foundation/general/handling-missing-information',
    assetPath: 'public/markdown/generated/ux-foundation/general/handling-missing-information.md',
    group: 'general',
    sourceRelativePath: 'general/handling-missing-information.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/low-affordance-high-value',
    title: 'Low affordance, high value',
    routePath: 'documents/ux-foundation/general/low-affordance-high-value',
    assetPath: 'public/markdown/generated/ux-foundation/general/low-affordance-high-value.md',
    group: 'general',
    sourceRelativePath: 'general/low-affordance-high-value.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/motion',
    title: 'Motion',
    routePath: 'documents/ux-foundation/general/motion',
    assetPath: 'public/markdown/generated/ux-foundation/general/motion.md',
    group: 'general',
    sourceRelativePath: 'general/motion.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/navigation',
    title: 'Navigation',
    routePath: 'documents/ux-foundation/general/navigation',
    assetPath: 'public/markdown/generated/ux-foundation/general/navigation.md',
    group: 'general',
    sourceRelativePath: 'general/navigation.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/ordering-information',
    title: 'Ordering information',
    routePath: 'documents/ux-foundation/general/ordering-information',
    assetPath: 'public/markdown/generated/ux-foundation/general/ordering-information.md',
    group: 'general',
    sourceRelativePath: 'general/ordering-information.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/piggyback-on-subcommunication',
    title: 'Piggyback on subcommunication',
    routePath: 'documents/ux-foundation/general/piggyback-on-subcommunication',
    assetPath: 'public/markdown/generated/ux-foundation/general/piggyback-on-subcommunication.md',
    group: 'general',
    sourceRelativePath: 'general/piggyback-on-subcommunication.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/surfaces-and-depth',
    title: 'Surfaces and depth',
    routePath: 'documents/ux-foundation/general/surfaces-and-depth',
    assetPath: 'public/markdown/generated/ux-foundation/general/surfaces-and-depth.md',
    group: 'general',
    sourceRelativePath: 'general/surfaces-and-depth.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/terminology-and-language',
    title: 'Terminology and language',
    routePath: 'documents/ux-foundation/general/terminology-and-language',
    assetPath: 'public/markdown/generated/ux-foundation/general/terminology-and-language.md',
    group: 'general',
    sourceRelativePath: 'general/terminology-and-language.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/the-one-box-rule',
    title: 'The one box rule',
    routePath: 'documents/ux-foundation/general/the-one-box-rule',
    assetPath: 'public/markdown/generated/ux-foundation/general/the-one-box-rule.md',
    group: 'general',
    sourceRelativePath: 'general/the-one-box-rule.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/the-thinking-behind-the-design-system',
    title: 'Why a design system',
    routePath: 'documents/ux-foundation/general/the-thinking-behind-the-design-system',
    assetPath: 'public/markdown/generated/ux-foundation/general/the-thinking-behind-the-design-system.md',
    group: 'general',
    sourceRelativePath: 'general/the-thinking-behind-the-design-system.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/trust-and-safety',
    title: 'Trust and safety',
    routePath: 'documents/ux-foundation/general/trust-and-safety',
    assetPath: 'public/markdown/generated/ux-foundation/general/trust-and-safety.md',
    group: 'general',
    sourceRelativePath: 'general/trust-and-safety.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/voice-by-surface',
    title: 'Voice by surface',
    routePath: 'documents/ux-foundation/general/voice-by-surface',
    assetPath: 'public/markdown/generated/ux-foundation/general/voice-by-surface.md',
    group: 'general',
    sourceRelativePath: 'general/voice-by-surface.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/what-actually-is-user-experience',
    title: 'What actually is user experience',
    routePath: 'documents/ux-foundation/general/what-actually-is-user-experience',
    assetPath: 'public/markdown/generated/ux-foundation/general/what-actually-is-user-experience.md',
    group: 'general',
    sourceRelativePath: 'general/what-actually-is-user-experience.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/why-you-shouldnt-show-everything',
    title: "Why you shouldn't show everything",
    routePath: 'documents/ux-foundation/general/why-you-shouldnt-show-everything',
    assetPath: 'public/markdown/generated/ux-foundation/general/why-you-shouldnt-show-everything.md',
    group: 'general',
    sourceRelativePath: 'general/why-you-shouldnt-show-everything.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/general/z-index',
    title: 'Z-index',
    routePath: 'documents/ux-foundation/general/z-index',
    assetPath: 'public/markdown/generated/ux-foundation/general/z-index.md',
    group: 'general',
    sourceRelativePath: 'general/z-index.md',
    isIndex: false,
  },
  {
    id: 'documents/ux-foundation/overview',
    title: 'Guidelines index',
    routePath: 'documents/ux-foundation/overview',
    assetPath: 'public/markdown/generated/ux-foundation/index.md',
    group: 'overview',
    sourceRelativePath: 'index.md',
    isIndex: true,
  },
] as const satisfies readonly GeneratedCatalogDocument[];

export const generatedCatalogDocumentDefaultRoute = 'documents/ux-foundation/overview';
